import * as Yup from "yup";

export const ValidationSchema = Yup.object({
  matrimonial_image: Yup.string().required("Matrimonial image is required!"),
  full_name: Yup.string().required("Full name is required!"),
  birth_date: Yup.string().required("Date of birth is required!"),
  marital_status: Yup.string().required("Marital status is required!"),
  gender: Yup.string()
    .oneOf(["Male", "Female"], "Please select a gender!")
    .required("Gender is required!"),
  matrimonial_document: Yup.string().required("Bio data file is required"),
  member_id: Yup.string().required("Member is required!"),
  is_active: Yup.string().required("Status is required!"),
});
